import React from 'react';
import { useLocation } from 'react-router';

import { ModulesScrollbar } from 'app/design-system/components/Scrollbar';
import { BettingMenu } from 'app/modules/BettingMenu';
import { isBettingMenu } from 'app/modules/BettingMenu/utils';
import { ServiceMenu } from 'app/modules/ServiceMenu';

import styles from './LeftMenu.module.scss';

export const LeftMenu: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <ModulesScrollbar className={styles.scrollbar}>
      {isBettingMenu(pathname) ? (
        <BettingMenu />
      ) : (
        <ServiceMenu />
      )}
    </ModulesScrollbar>
  );
};
